import axiosClient from "./axiosClient";

export const loginAdmin = async (username, password) => {
  const response = await axiosClient.post("/auth/login", {
    username: username,
    password: password,
  });

  return response.data;
};
